export const EVENTS = {
  SDUI_FETCH: 'SDUI.fetch'
};